// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {createAllClaimsPayload} from '../services/all-claims-payload';
import {getAllClaimResults} from '../../shared/repositories';
import {getFileName} from '../../../shared/services/get-file-name';
import {openFile} from '../../../shared/services/open-file';

/* eslint-disable complexity, max-params */

export const exportToExcel = (facets, language, showDealerInvoice, layoutName, listId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = createAllClaimsPayload(facets, 'EXCEL', language, showDealerInvoice, layoutName, listId);

        try {

            const response = await getAllClaimResults(payload);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/claim/all-claims/action-creators/export-to-excel.js